import ExpertMarketLogo from './ExpertMarketLogo';
import ExpertReviewsLogo from './ExpertReviewsLogo';
import GoWizardLogo from './GoWizardLogo';
import StartupsLogo from './StartupsLogo';
import TechcoLogo from './TechcoLogo';
import TheEcoExpertsLogo from './TheEcoExpertsLogo';
import WebsiteBuilderExpertLogo from './WebsiteBuilderExpertLogo';
import HearClearLogo from './HearClearLogo';
import LasikEyesLogo from './LasikEyesLogo';
import ExpertsInMoneyLogo from './ExpertsInMoneyLogo';
import ClinicCompareLogo from './ClinicCompareLogo';
import ProFindLogo from './ProFindLogo';
import EduCompareLogo from './EduCompareLogo';
import InsideLaneLogo from './InsideLaneLogo';
import ThePrepLogo from './ThePrepLogo';
import MintPillowLogo from './MintPillowLogo';
import RaiseTheBarLogo from './RaiseTheBarLogo';
import TheNetGainsLogo from './TheNetGainsLogo';
import DentalBiteLogo from './DentalBiteLogo';
import TheLevelLogo from './TheLevelLogo';
import TheSKUpeLogo from './TheSKUpeLogo';

const brandLogos = {
  default: ExpertMarketLogo,
  expertReviews: ExpertReviewsLogo,
  techco: TechcoLogo,
  startups: StartupsLogo,
  gowizard: GoWizardLogo,
  theEcoExperts: TheEcoExpertsLogo,
  websiteBuilderExpert: WebsiteBuilderExpertLogo,
  hearClear: HearClearLogo,
  lasikEyes: LasikEyesLogo,
  expertsInMoney: ExpertsInMoneyLogo,
  clinicCompare: ClinicCompareLogo,
  proFind: ProFindLogo,
  eduCompare: EduCompareLogo,
  theLevel: TheLevelLogo,
  insideLane: InsideLaneLogo,
  thePrep: ThePrepLogo,
  mintPillow: MintPillowLogo,
  raiseTheBar: RaiseTheBarLogo,
  theNetGains: TheNetGainsLogo,
  dentalBite: DentalBiteLogo,
  theSKUpe: TheSKUpeLogo,
  none: null,
};

export default brandLogos;
